// Enum for table columns (API response fields)
export enum EmployeeTableColumn {
  COMPANY_NAME = "company_name",
  LEAD_NAME = "lead_name",
  PHONE = "phone",
  EMAIL = "email",
  TYPE_NAME = "type_name",
  INDUSTRY_NAME = "industry_name",
  ENQUIRY_CATEGORY_NAME = "enquiry_category_name",
  STATUS_TITLE_NAME = "status_title_name",
}

// Enum for export columns (backend expected fields)
export enum EmployeeExportColumn {
  COMPANY_NAME = "company_name",
  LEAD_NAME = "lead_name",
  PHONE = "phone",
  EMAIL = "email",
  TYPE_NAME = "type__name",
  INDUSTRY_NAME = "industry__name",
  ENQUIRY_CATEGORY_NAME = "enquiry_category__name",
  STATUS_TITLE_NAME = "status_title_name",
}

// Column display names mapping (for UI)
export const EmployeeColumnLabels: Record<EmployeeTableColumn, string> = {
  [EmployeeTableColumn.COMPANY_NAME]: "Company",
  [EmployeeTableColumn.LEAD_NAME]: "Lead Name",
  [EmployeeTableColumn.PHONE]: "Contact",
  [EmployeeTableColumn.EMAIL]: "Email",
  [EmployeeTableColumn.TYPE_NAME]: "Type",
  [EmployeeTableColumn.INDUSTRY_NAME]: "Industry",
  [EmployeeTableColumn.ENQUIRY_CATEGORY_NAME]: "Enquiry Category",
  [EmployeeTableColumn.STATUS_TITLE_NAME]: "Follow up Status",
};

// Default selected columns for export (all true)
export const getDefaultEmployeeSelectedColumns = () => ({
  [EmployeeExportColumn.COMPANY_NAME]: true,
  [EmployeeExportColumn.LEAD_NAME]: true,
  [EmployeeExportColumn.PHONE]: true,
  [EmployeeExportColumn.EMAIL]: true,
  [EmployeeExportColumn.TYPE_NAME]: true,
  [EmployeeExportColumn.INDUSTRY_NAME]: true,
  [EmployeeExportColumn.ENQUIRY_CATEGORY_NAME]: true,
  [EmployeeExportColumn.STATUS_TITLE_NAME]: true,
});
